import type { ComponentPropsWithRef } from 'react'

import type { TextField } from '@fv/client-components'
import { FvButton } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

import { InputAdornment, InputGroup } from '@/components/inputs/InputGroup'
import { ShipperTooltip } from '@/components/ShipperTooltip'

import { useRequiresTechnicalName } from './cfrHazmat'

type Props = PropsWithClassName<{
  inputProps: ComponentPropsWithRef<typeof TextField>
  locked?: boolean
  properShippingName?: string
}>

export const TechnicalNameField = ({
  className,
  inputProps,
  locked,
  properShippingName,
}: Props) => {
  const requiresTechnicalName = useRequiresTechnicalName(properShippingName)

  return (
    <InputGroup
      className={className}
      inputProps={inputProps}
      inputType="text"
      label="Technical name"
      locked={locked}
      endContent={
        requiresTechnicalName && !inputProps.value ? (
          <InputAdornment position="end">
            <ShipperTooltip label="A technical name is recommended for this commodity per CFR regulations.">
              <FvButton
                className="!bg-fv-beer-xlight border-2 border-fv-orange-bright outline-2 !outline-dotted !outline-fv-orange-bright !outline-offset-[3px] relative z-10"
                icon="exclamation-triangle"
                iconClass="text-fv-orange-bright"
                theme="default"
              />
            </ShipperTooltip>
          </InputAdornment>
        ) : undefined
      }
    />
  )
}
